import { CardInfo } from './CardInfo';
import { DutyInfo } from './DutyInfo';
import { SeatInfo } from './SeatInfo';
import { BeltInfo } from './BeltInfo';
import { VehicleInfo } from './VehicleInfo';
import { AiOutlineClose } from 'react-icons/ai';
import { WiDirectionUpRight } from 'react-icons/wi';
export const Info = ({
  typeInfo,
  cardInfo,
  locationInfo,
  vehicleInfo,
  adress,
  adressLoading,
  setInfoBarVisible,
  seatInfo,
  beltInfo,
}) => {
  const renderTab = () => {
    switch (typeInfo) {
      case 'Vehicle':
        return <VehicleInfo data={vehicleInfo} />;
      case 'Card':
        return <CardInfo data={cardInfo} />;
      case 'Point':
        return <DutyInfo data={locationInfo} />;
      case 'Seat':
        return <SeatInfo data={seatInfo} />;
      case 'Belt':
        return <BeltInfo data={beltInfo} />;
    }
  };

  return (
    <div className="py-1 my-1 bg-white rounded-2xl md:text-lg text-xs w-full">
      <div className="flex w-full justify-between items-center">
        <div className="flex w-full gap-2 p-2">
          {typeInfo === 'Vehicle' && (
            <div
              className={`
                             text-white bg-[#304564]
                             text-xs cursor-pointer rounded-md  flex items-center px-2 py-1 delay-75`}
            >
              Araç Bilgileri
            </div>
          )}
          {typeInfo === 'Card' && (
            <div
              className={` text-white bg-[#304564]
                             text-xs cursor-pointer rounded-md  flex items-center px-2 py-1 delay-75`}
            >
              Kart Bilgileri
            </div>
          )}
          {typeInfo === 'Point' && (
            <div
              className={` text-white bg-[#304564]
                             text-xs cursor-pointer rounded-md  flex items-center px-2 py-1 delay-75`}
            >
              Nokta Bilgileri
            </div>
          )}
          {typeInfo === 'Belt' && (
            <div
              className={` text-white bg-[#304564]
                             text-xs cursor-pointer rounded-md  flex items-center px-2 py-1 delay-75`}
            >
              Kemer Durum Bilgileri
            </div>
          )}
          {typeInfo === 'Seat' && (
            <div
              className={` text-white bg-[#304564]
                             text-xs cursor-pointer rounded-md  flex items-center px-2 py-1 delay-75`}
            >
              Koltuk Durum Bilgileri
            </div>
          )}
        </div>
        <button onClick={() => setInfoBarVisible(false)} className="p-3">
          <AiOutlineClose size={15} />
        </button>
      </div>
      <div className="w-full h-0.5 bg-gray-200"></div>
      <div className="w-full h-full">{renderTab()}</div>
      <div className="w-full h-0.5 bg-gray-200"></div>
      <div className="flex w-full justify-beetween items-center p-2">
        <div className="flex items-center text-sm">
          <span className=" text-gray-500">Konum:</span>
          <span className="ml-1 ">
            {adressLoading ? 'Yükleniyor...' : adress}
          </span>
        </div>
      </div>
    </div>
  );
};
